module.exports = __webpack_public_path__ + "img/troubleshoot.f38d040f.png";